export const EndStateIcon = () => (
  <svg
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="72" height="72" rx="36" fill="white" />
    <g clipPath="url(#clip0_3751_7192)">
      <path
        d="M42.9707 18H24.9604C22.7731 18 21 19.7732 21 21.9605V44.403C21 46.5903 22.7731 48.3635 24.9604 48.3635H42.9707C45.158 48.3635 46.9311 46.5903 46.9311 44.403V21.9605C46.9311 19.7732 45.158 18 42.9707 18Z"
        fill="#FCD9EF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4629 27.8301H43.2222V29.0456H35.4629V27.8301Z"
        fill="#F8B1DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4629 23.8711H43.2222V25.0866H35.4629V23.8711Z"
        fill="#F8B1DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.6738 38.5137H43.224V39.7292H25.6738V38.5137Z"
        fill="#F8B1DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.707 34.5547H43.2223V35.7702H24.707V34.5547Z"
        fill="#F8B1DC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M25.7598 42.4746H42.1725V43.6901H25.7598V42.4746Z"
        fill="#F8B1DC"
      />
      <path
        d="M30.8399 22.082H27.2752C25.8439 22.082 24.6836 23.2424 24.6836 24.6737V28.2384C24.6836 29.6698 25.8439 30.8301 27.2752 30.8301H30.8399C32.2712 30.8301 33.4315 29.6698 33.4315 28.2384V24.6737C33.4315 23.2424 32.2712 22.082 30.8399 22.082Z"
        fill="#072462"
      />
      <path
        d="M31.5753 29.4869C31.5753 28.0962 30.4479 26.9688 29.0572 26.9688C27.6665 26.9688 26.5391 28.0962 26.5391 29.4869H31.5753Z"
        fill="white"
      />
      <path
        d="M29.0579 26.3326C29.7532 26.3326 30.3169 25.7689 30.3169 25.0735C30.3169 24.3782 29.7532 23.8145 29.0579 23.8145C28.3625 23.8145 27.7988 24.3782 27.7988 25.0735C27.7988 25.7689 28.3625 26.3326 29.0579 26.3326Z"
        fill="white"
      />
      <path
        d="M43.9811 53.9546C48.4094 53.9546 51.9993 50.3647 51.9993 45.9363C51.9993 41.5079 48.4094 37.918 43.9811 37.918C39.5528 37.918 35.9629 41.5079 35.9629 45.9363C35.9629 50.3647 39.5528 53.9546 43.9811 53.9546Z"
        fill="#EE399E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M47.8104 43.4423C48.2048 43.8366 48.2048 44.476 47.8104 44.8704L43.6443 49.0366C43.4549 49.226 43.198 49.3324 42.9302 49.3324C42.6624 49.3324 42.4055 49.226 42.2161 49.0366L40.0614 46.8819C39.667 46.4875 39.667 45.8481 40.0614 45.4537C40.4558 45.0594 41.0952 45.0594 41.4896 45.4537L42.9302 46.8944L46.3823 43.4423C46.7766 43.0479 47.416 43.0479 47.8104 43.4423Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_3751_7192">
        <rect
          width="31"
          height="35.9555"
          fill="white"
          transform="translate(21 18)"
        />
      </clipPath>
    </defs>
  </svg>
);
